import React from "react";

import Blocks from "components/form/Blocks";

import useCategoryApi from "hooks/api/private/useCategoryApi";

function CategoryBlocksForm({ categoryId }: { categoryId: string }) {
    const { getOneCategory } = useCategoryApi();

    const [blockGroupId, setBlockGroupId] = React.useState<string | null>(null);

    React.useEffect(() => {
        const [apiCall, abortController] = getOneCategory({ id: categoryId });

        apiCall.then((category) => setBlockGroupId(category.block_group_id));

        return () => abortController.abort();
    }, [getOneCategory, categoryId]);

    return <>{blockGroupId && <Blocks blockGroupId={blockGroupId} />}</>;
}

export default CategoryBlocksForm;
